

export const getNumber = (val) => {
    const colGap = val;
    const columnGap = colGap.match(/\d/g);
    const gutterX = parseInt(columnGap.join(""));
    return gutterX;
}

export const getBoxValue = object => Object.values(object).join(" ");